import CTAButton from '../components/CTAButton';
import { FaVrCardboard, FaArrowsAlt, FaCube, FaGlobe } from 'react-icons/fa';
import { HiOutlineSparkles } from 'react-icons/hi';
import arvrImage from '../Assert/3.png';
import useDocumentTitle from '../hooks/useDocumentTitle';

const experienceImg = require('../Assert/14.jpg');

function ARVR() {
  useDocumentTitle('AR/VR Solutions — MMI');

  return (
    <main className="arvr-page">
      {/* Hero Section */}
      <section className="arvr-hero">
        <div className="container">
          <div className="hero-two-column">
            {/* Left Column - Text */}
            <div className="hero-left">
              <h1 className="hero-title">
                We Were Building
                <br />
                <span className="gradient-text">Immersive Worlds</span>
                <br />
                Before It Had a Name.
              </h1>
            </div>
            {/* Right Column - Image */}
            <div className="hero-right">
              <div className="hero-image-container">
                <div className="hero-media">
                  <video
                    className="hero-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={arvrImage}
                  >
                    <source src="/videos/ar-vr.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="hero-image-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section">
        <div className="container">
          <div className="experience-wrapper">
            <div className="experience-content">
              <p className="experience-subtitle">
                This is not new territory for us. Breathing room above and below
              </p>
              <p className="experience-text">
                When most companies were still figuring out what AR/VR meant, MMI was already shipping it 
                — games, simulations, interactive environments. We bring that decade-plus of experience 
                into every project. Our AR/VR work is where the immersive past of MMI meets the intelligent 
                present. Every experience we build now has AI running underneath it.
              </p>
            </div>
            <div className="experience-media">
              <div className="assert-image-wrap">
                <img src={experienceImg} alt="AR/VR experience" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialties Section */}
      <section className="specialties-section">
        <div className="container">
          <div className="specialties-header">
            <HiOutlineSparkles className="specialties-icon" />
            <h2 className="specialties-heading">Our Specialties</h2>
          </div>
          
          <div className="specialties-grid">
            {/* VR Simulations */}
            <div className="specialty-card">
              <div className="specialty-icon-wrapper">
                <FaVrCardboard className="specialty-icon" />
              </div>
              <div className="specialty-content">
                <h3 className="specialty-title">VR Simulations</h3>
                <p className="specialty-description">
                  High-fidelity virtual training environments for complex industrial and medical procedures.
                </p>
              </div>
            </div>

            {/* AR Simulations */}
            <div className="specialty-card">
              <div className="specialty-icon-wrapper">
                <FaArrowsAlt className="specialty-icon" />
              </div>
              <div className="specialty-content">
                <h3 className="specialty-title">AR Simulations</h3>
                <p className="specialty-description">
                  Real-time digital overlays that enhance physical workflows and field operations.
                </p>
              </div>
            </div>

            {/* Interactive 3D Experiences */}
            <div className="specialty-card">
              <div className="specialty-icon-wrapper">
                <FaCube className="specialty-icon" />
              </div>
              <div className="specialty-content">
                <h3 className="specialty-title">Interactive 3D Experiences</h3>
                <p className="specialty-description">
                  Web-based and standalone 3D applications for immersive product storytelling.
                </p>
              </div>
            </div>

            {/* Metaverse Experiences */}
            <div className="specialty-card">
              <div className="specialty-icon-wrapper">
                <FaGlobe className="specialty-icon" />
              </div>
              <div className="specialty-content">
                <h3 className="specialty-title">Metaverse Experiences</h3>
                <p className="specialty-description">
                  Scalable persistent virtual spaces for global collaboration and social engagement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="arvr-cta">
        <div className="container">
          <div className="cta-box">
            <h2 className="cta-title">
              Ready to <span className="gradient-text">Build?</span>
            </h2>
            <CTAButton text="Book a Call" to="/contact" />
          </div>
        </div>
      </section>

    
    </main>
  );
}

export default ARVR;